module.exports = __webpack_public_path__ + "fonts/Mukta-700-latin-ext17.db09e00.woff2";